
import emailjs from 'emailjs-com';

// EmailJS credentials
const EMAILJS_SERVICE_ID = "service_o1hsb6y"; 
const EMAILJS_TEMPLATE_ID = "template_8qjee5r"; 
const EMAILJS_USER_ID = "tXQ0D44SeFXOT2nss"; 

export interface EmailTemplateParams {
  first_name: string;
  last_Name: string;
  company_name: string;
  job_title: string;
  email_address: string;
  mobile_number: string;
  Company_Address_Line_1: string;
  Company_Address_Line_2: string;
  Company_Address_Line_3: string;
  Postal_Code: string;
  interests: string;
  message: string;
  from_name?: string;
  to_name?: string;
  country?: string; // Added country field
  username?: string; // Added username field
  password?: string; // Added password field
  [key: string]: string | undefined; // Add index signature to allow any string key
}

export const sendPricingRequest = async (templateParams: EmailTemplateParams) => {
  console.log("Sending email with data:", templateParams);
  
  try {
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams,
      EMAILJS_USER_ID
    );
    
    console.log("Email sent successfully:", response);
    return response;
  } catch (error: any) {
    console.error("EmailJS Error:", error);
    throw new Error(`Email failed: ${error.text || error.message || 'Unknown error'}`);
  }
};
